import React from 'react';
export function Footer() {
  return <footer className="w-full py-8 px-4 bg-brown text-cream/80 text-center" data-id="element-77">
      <div className="max-w-3xl mx-auto" data-id="element-78">
        <p className="font-serif text-xs md:text-sm leading-relaxed opacity-80" data-id="element-79">
          Disclaimer: Dies ist ein persönlicher Erfahrungsbericht. Ergebnisse
          können individuell variieren. Bei anhaltenden Beschwerden bitte einen
          Tierarzt aufsuchen.
        </p>
        <p className="font-serif text-xs mt-4 opacity-60" data-id="element-80">
          &copy; {new Date().getFullYear()} Napftagebuch. Alle Rechte
          vorbehalten.
        </p>
      </div>
    </footer>;
}